import axios from 'axios';
import connection from './connection';
import { CommonResponse, GlobalPriceChartRequest, GlobalPriceChartResponseModel } from "@gtpl/shared-models/masters";

export class GlobalPriceChartService{
    URL = connection.DEPLOY_URL + '/global-price-chart';


    async updatePriceCharts(dto: GlobalPriceChartRequest): Promise<GlobalPriceChartResponseModel> {
        return await axios.post(this.URL + '/updatePriceCharts',dto).then(res => {
                return res.data
        })
    }

    async getAllPriceCharts(): Promise<GlobalPriceChartResponseModel> {
        return await axios.post(this.URL + '/getAllPriceCharts').then(res => {
            return res.data
        })
    }
    async getAntiDumpingPrice(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAntiDumpingPrice').then(res => {
            return res.data
        })
    }     

}